/* eslint-disable complexity */
import { BookWidgetShopMilesField } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareShopMilesField = (
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  hasDeepLinkingParams: boolean
): BookWidgetShopMilesField => {
  if (bookWidgetFieldsMasterConfig.shopMilesField?.hide) {
    return {
      checked: false,
      disable: false,
      hide: true
    };
  }

  let checked = false;
  if (loginDashboardFieldsConfig?.disableMiles) {
    checked = false;
  } else if (
    !bookWidgetFieldsMasterConfig?.shopMilesField?.disable &&
    stringToBoolean(queryParams?.awardTravel)
  ) {
    checked = true;
  } else if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.shopMilesField?.disable &&
    retrieveSearchData?.awardTravel
  ) {
    checked = true;
  }

  return {
    checked,
    disable: bookWidgetFieldsMasterConfig.shopMilesField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.shopMilesField?.hide || false
  };
};
